module.exports = {
  respCodes: require('./respCodes'),
  accountType: require('./accountType'),
  dictOperationReason: require('./dictOperationReason'),
  personType: require('./personType'),
  keyType: require('./keyType'),
  claimType: require('./claimType'),
  claimStatus: require('./claimStatus'),
  qrcodeStatus: require('./qrcodeStatus'),
  refundStatus: require('./refundStatus')
};
